import ExpansibleContentBase from '../components/expandible-table-items-base/extensible-content-base';
import ItemExpansibleBase from '../components/expandible-table-items-base/item-expandible-base';
import PriceTagItem from '../components/price-tag/price-tag-item';
import PropTypes from 'prop-types';
import QuotationAvailableByCarsDataItem from './data-item';
import RangeIndicator from '../components/slider-indicator/slider-indicator';
import styles from 'styles/LandingTablesComponents.module.scss';
import styles1 from 'styles/LandingExpansibleTable.module.scss';
import useRichTranslation from 'hooks/useRichTranslation';
import { useState } from 'react';

const QuotationAvailableByCarsItem = ({
    isOpen,
    setOpen,
    familyCode,
    price,
    totalCoverItems,
    coverItems,
    items,
    peopleChoice,
    colorSchema,
    carName
}) => {
    const t = useRichTranslation();
    const [isBacksideOpen, setBacksideOpen] = useState(false);
    function showBacksideHandler () {
        setBacksideOpen(true);
    }
    function hideBacksideHandler () {
        setBacksideOpen(false);
    }
    return (
        <ItemExpansibleBase
            colorSchema={colorSchema}
            carName={carName}
            isOpen={isOpen}
            openHandler={() => setOpen(true)}
            closeHandler={() => setOpen(false)}
            showBacksideHandler={showBacksideHandler}
            hideBacksideHandler={hideBacksideHandler}
            isBacksideOpen={isBacksideOpen}
            ctaLabel={t('table.quotation-available-by-car.item.cta-label')}
            ctaHref={t('quoter')}
            topNode={
                <p className={`${styles.label} ${styles.top}`}>{familyCode}</p>
            }
            upperNode={
                <>
                    {price && (
                        <PriceTagItem
                            tagType="price-label"
                            value={Math.round(price)}
                            fontSize={20}
                        />
                    )}
                </>
            }
            bottomNode={
                <div className={`${styles1.bottom_wrapper} ${styles1.item}`}>
                    <p>
                        <strong>{peopleChoice}%</strong> {t('table.quotation-available-by-car.item.people-choice')}
                    </p>
                    <RangeIndicator
                        range={100}
                        width={140}
                        value={peopleChoice}
                        colorSchema={colorSchema}
                    />
                </div>
            }
        >
            <ExpansibleContentBase isOpen={isOpen}>
                {isOpen ?
                    (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <p
                                    style={{ fontSize: 12 }}
                                    className={`${styles.label} ${styles.item}`}
                                >
                                    <strong>{coverItems}</strong> {t('table.quotation-available-by-car.item.of')}{' '}
                                    <strong>{totalCoverItems}</strong>{' '}
                                    {t('table.quotation-available-by-car.item.item-covered')}
                                </p>
                            </div>
                            {items
                                .filter((item, index) => index < 7)
                                .map((item, index) => {
                                    if (item) {
                                        return (
                                            <QuotationAvailableByCarsDataItem
                                                key={item.code}
                                                data={item.value}
                                                colorSchema={colorSchema}
                                            />
                                        );
                                    } else {
                                        return (
                                            <QuotationAvailableByCarsDataItem
                                                key={'null' + index}
                                                data=""
                                                colorSchema={colorSchema}
                                            />
                                        );
                                    }
                                })}
                        </>
                    ) :
                    (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <p
                                style={{ fontSize: 12 }}
                                className={`${styles.label} ${styles.item}`}
                            >
                                <strong>{coverItems}</strong> {t('of')}{' '}
                                <strong>{totalCoverItems}</strong>{' '}
                                {t('table.quotation-available-by-car.item.item-covered')}
                            </p>
                        </div>
                    )}
            </ExpansibleContentBase>
        </ItemExpansibleBase>
    );
};

QuotationAvailableByCarsItem.propTypes = {
    isOpen: PropTypes.bool,
    setOpen: PropTypes.func,
    familyCode: PropTypes.string,
    price: PropTypes.number,
    totalCoverItems: PropTypes.number,
    coverItems: PropTypes.number,
    items: PropTypes.array,
    columnsItem: PropTypes.array,
    colorSchema: PropTypes.string,
    peopleChoice: PropTypes.number,
    carName: PropTypes.string
};

export default QuotationAvailableByCarsItem;
